import { MouseEventHandler, ReactNode } from 'react';

import { LegacyDropdownTriggerContainer } from './LegacyDropdown.styled';

type Props = {
  onTriggerClick?: MouseEventHandler;
  qaId?: string;
  ariaLabel?: string;
  title: ReactNode;
  noPadding?: boolean;
};

export function LegacyTrigger({
  onTriggerClick,
  qaId,
  ariaLabel,
  title,
  noPadding,
}: Props) {
  return (
    <LegacyDropdownTriggerContainer
      onClick={onTriggerClick}
      data-qa-id={qaId ? `${qaId}-toggle` : undefined}
      aria-label={ariaLabel}
      $noPadding={noPadding}
    >
      <div>{title}</div>
    </LegacyDropdownTriggerContainer>
  );
}
